import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../../ui/card';

const TechnologySlide = ({ data }) => {
  const categoryColors = {
    'AI/ML': 'from-purple-500/20 to-purple-600/20 border-purple-500/30',
    'Protocols': 'from-cyan-500/20 to-cyan-600/20 border-cyan-500/30',
    'Network': 'from-teal-500/20 to-teal-600/20 border-teal-500/30',
    'Security': 'from-emerald-500/20 to-emerald-600/20 border-emerald-500/30',
  };

  const categoryTextColors = {
    'AI/ML': 'text-purple-400',
    'Protocols': 'text-cyan-400',
    'Network': 'text-teal-400',
    'Security': 'text-emerald-400',
  };

  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-10"
      >
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">{data.title}</h2>
        <p className="text-xl text-slate-400">{data.subtitle}</p>
      </motion.div>

      {/* Tech Stack Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {data.stack.map((stack, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 + index * 0.1 }}
          >
            <Card className={`bg-gradient-to-br ${categoryColors[stack.category]} p-6 h-full`}>
              <h3 className={`text-lg font-bold mb-4 ${categoryTextColors[stack.category]}`}>
                {stack.category}
              </h3>
              <ul className="space-y-2">
                {stack.items.map((item, i) => (
                  <li key={i} className="text-slate-300 text-sm flex items-center gap-2">
                    <span className={`w-1.5 h-1.5 rounded-full ${categoryTextColors[stack.category].replace('text-', 'bg-')}`} />
                    {item}
                  </li>
                ))}
              </ul>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default TechnologySlide;
